import ContenidoEnriquecido from '../../components/ContenidoEnriquecido';
import { formatearFechaCompleta } from '../../utils/utils';
import React from 'react'

const MensajeChat = ({ data , viewerIsAdmin}) => {

  const msgIsAdmin = data.isAdmin === true || data.isAdmin === "true";
  const amIAdmin = viewerIsAdmin === true || viewerIsAdmin === "true";

  const esMio = msgIsAdmin === amIAdmin;

  return (
    <div className={`flex w-full mb-6 ${esMio ? 'justify-end' : 'justify-start'}`}>
      <div className={`max-w-[85%] flex flex-col ${esMio ? 'items-end' : 'items-start'}`}>
        
        {/* Nombre del Asesor / Rol */}
        <span className="text-[10px] font-black uppercase opacity-50 mb-1 px-2">
          {data.asesor || "Sistema"}
        </span>

        {/* Burbuja de Mensaje: Azul si es mío, Gris si es del otro */}
        <div className={`p-4 rounded-2xl shadow-sm text-base ${
          esMio 
            ? 'bg-blue-600 text-white rounded-tr-none' 
            : 'bg-gray-100 text-gray-800 rounded-tl-none border border-gray-200'
        }`}>
          <div className={esMio ? 'text-gray-800' : 'text-gray-800'}>
            <ContenidoEnriquecido 
              contenido={data.mensaje} 
              isAdmin={false}
              editable={false}
            />
          </div>
        </div>

        {/* Fecha */}
        <span className="text-[9px] mt-1 opacity-40 font-bold uppercase px-1">
          {formatearFechaCompleta(data.fecha)}
        </span>
      </div>
    </div>
  );
  
};

export default MensajeChat
